<template>
    <login></login>
</template>

<script>
import Login from '../login/'
export default {
  components: {
    'Login': Login
  },
  data () {
    return {
    }
  },
  mounted () {
    this.$store.commit('toastr', {
      color: 'error',
      texto: 'Sessão expirada'
    })
  }
}
</script>



// WEBPACK FOOTER //
// expirado.vue?831151b4